
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 17","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.832 1.184a10.712 10.712 0 00-4.113-.809C13.394.375 9.07 2.59 4.746 2.59c-1.09 0-2.18-.14-3.27-.492a1.249 1.249 0 00-.351-.07A1.131 1.131 0 000 3.151v11.18c0 .422.246.844.633 1.02 1.37.562 2.742.773 4.113.773 4.324 0 8.649-2.18 12.973-2.18 1.09 0 2.18.14 3.27.492.105.036.245.036.35.036.599 0 1.161-.457 1.161-1.09V2.203c0-.422-.281-.844-.668-1.02zM11.25 11.625c-1.582 0-2.813-1.477-2.813-3.375 0-1.863 1.231-3.375 2.813-3.375 1.547 0 2.813 1.512 2.813 3.375 0 1.898-1.266 3.375-2.813 3.375z"}})])
          )
        }
      }
    